// src/components/SearchResultDialog.js (Versión con Formato Mejorado)
import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  Typography, 
  CircularProgress, 
  Box,
  Chip // Importamos Chip para las etiquetas
} from '@mui/material';
import { useSearch } from '../context/SearchContext';

const SearchResultDialog = () => {
  const { isSearchOpen, closeSearch, searchResult, isLoading } = useSearch();

  const renderContent = () => {
    if (isLoading) {
      return <CircularProgress />;
    }
    if (!searchResult) {
      return null; // No muestra nada si no hay resultado (antes de la primera búsqueda)
    }
    if (searchResult.error) {
      return <Typography color="error">{searchResult.error}</Typography>;
    }
    
    const { type, data } = searchResult;
    
    // --- NUEVA LÓGICA DE FORMATO ---
    
    if (type === 'Firm') {
      return (
        <Box textAlign="center">
          <Typography variant="h6" gutterBottom>
            {data.address_key}
          </Typography>
          <Box>
            <Chip label="Firm" color="success" sx={{ mr: 1 }} />
            <Chip label={`Route ${data.route}`} color="primary" />
          </Box>
        </Box>
      );
    }

    if (type === 'StreetRange') {
      // Para los rangos, necesitamos reconstruir la dirección buscada.
      // Por ahora, mostraremos la información del rango de forma clara.
      return (
        <Box textAlign="center">
          <Typography variant="h6" gutterBottom>
            {data.street_name}
          </Typography>
          <Typography variant="body1" gutterBottom>
            Range: {data.start_number} - {data.end_number}
          </Typography>
          <Chip label={`Route ${data.route}`} color="primary" />
        </Box>
      );
    }
    
    return <Typography>No results found.</Typography>;
  };

  return (
    <Dialog open={isSearchOpen} onClose={closeSearch} fullWidth maxWidth="sm">
      <DialogTitle sx={{ textAlign: 'center' }}>Search Result</DialogTitle>
      <DialogContent>
        <Box sx={{ minHeight: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
          {renderContent()}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SearchResultDialog;
